import WaveSurfer from "wavesurfer.js";

((Drupal, drupalSettings) => {
  const formatTime = (timestampInSeconds) => {
    let timeString = "";
    const hours = Math.floor(timestampInSeconds / 60 / 60);
    const minutes = Math.floor(timestampInSeconds / 60) - hours * 60;
    const seconds = timestampInSeconds % 60;

    if (hours > 0) {
      timeString += `${hours.toString().padStart(1, "0")}:`;
    }

    timeString += `${timeString}${minutes.toString().padStart(1, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;

    return timeString;
  };

  Drupal.behaviors.wwf_audio_containers = {
    attach(context, settings) {
      const audioContainers = once(
        "wwf_audio_containers",
        ".paragraph.paragraph--audio",
        context
      );

      audioContainers.forEach((container) => {
        const paraId = Array.from(container.classList).pop().split("-").pop();
        const timer = Number(drupalSettings.audio[paraId].timer);

        const playBtn = container.querySelector(".play");
        const timeRemaining = container.querySelector(".time-remaining > span");

        const wave = WaveSurfer.create({
          container: container.querySelector(".waveform"),
          waveColor: drupalSettings.audio[paraId].waveColor,
          progressColor: drupalSettings.audio[paraId].progressColor,
          cursorColor: drupalSettings.audio[paraId].cursorColor,
          mediaType: "audio",
          barWidth: 3,
          responsive: true,
          hideScrollbar: true,
          barRadius: 3,
          barGap: 3,
          barHeight: 2,
          height: "auto",
          normalize: true,
        });

        wave.load(drupalSettings.audio[paraId].url);

        wave.on("ready", function () {
          const secondsRemaining = Number(wave.getDuration().toFixed(0));
          timeRemaining.innerHTML = `- ${formatTime(secondsRemaining)}`;
        });

        wave.on("audioprocess", function () {
          if (wave.isPlaying()) {
            const totalTime = wave.getDuration();
            const currentTime = wave.getCurrentTime();
            const remainingTime = totalTime - currentTime;
            const secondsRemaining = Number(remainingTime.toFixed(0));
            timeRemaining.innerHTML = `- ${formatTime(secondsRemaining)}`;
          }
        });

        wave.on("seeking", function (position) {
          const currentTime = wave.getDuration() - position;
          const secondsRemaining = Number(currentTime.toFixed(0));
          timeRemaining.innerHTML = `- ${formatTime(secondsRemaining)}`;
        });

        playBtn.addEventListener("click", (event) => {
          wave.playPause();
          if (wave.isPlaying()) {
            playBtn.innerHTML = `<img src="/themes/custom/wwf/img/media-player/${drupalSettings.audio[paraId].theme}/pause.svg" alt="Pause" />`;
          } else {
            playBtn.innerHTML = `<img src="/themes/custom/wwf/img/media-player/${drupalSettings.audio[paraId].theme}/play.svg" alt="Play" />`;
          }
        });
      });
    },
  };
})(Drupal, drupalSettings);
